import AbstractForm from '@/zenky/forms/AbstractForm';
import ProductVariant from '@/zenky/interfaces/products/ProductVariant';
import FormField from '@/zenky/forms/fields/FormField';
import TextField from '@/zenky/forms/fields/common/TextField';
import ProductPricesField from '@/forms/fields/products/ProductPricesField';
import ProductRemaindersField from '@/forms/fields/products/ProductRemaindersField';
import FormSection from '@/zenky/forms/FormSection';
import ProductVariantDataExtractor from '@/resources/products/variants/ProductVariantDataExtractor';
import ProductDimensionsField from '@/forms/fields/products/ProductDimensionsField';

export default class EditProductVariantForm extends AbstractForm {
  constructor(protected variant: ProductVariant) {
    super();

    this.setFieldValues(
      new ProductVariantDataExtractor().getVariant(variant),
    );
  }

  method(): string {
    return 'PUT';
  }

  action(): string {
    return `products/${this.variant.product_id}/variants/${this.variant.id}`;
  }

  fields(): FormField[] {
    return [
      new TextField('name', 'Название')
        .withAttribute('placeholder', 'Введите название варианта'),
      new ProductPricesField('prices', 'Цены').disableLabel(),
      new ProductRemaindersField('remainders', 'Остатки').disableLabel(),
      new ProductDimensionsField('dimensions', 'Вес и габариты').disableLabel(),
    ];
  }

  sections(): FormSection[] {
    return this.extractFieldsToSections([
      { fields: ['name'] },
      { label: 'Цены', fields: ['prices'] },
      { label: 'Остатки', fields: ['remainders'] },
      { label: 'Вес и габариты', fields: ['dimensions'] },
    ]);
  }
}
